module.exports = __webpack_public_path__ + "media/images/views/tech_client/header-phone-pc-6ec4fdf2874e96a51acaf3e6a2cd33db.png";